function ProjectDetails() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Project.Details visual. <br/>
   /// <br/>
    /// Author: MWI<br />
    /// Date: 12.05.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// *** v1.0.1 - 06.06.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - added support for more buttons                                   *<br />
    /// * - documentation                                   *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 12.05.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>                                                                                                                                           f
   
}
ProjectDetails.prototype = new window.vcTemplate();
ProjectDetails.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it does nothing more than adding the clickhandler 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        
        me.initClickHandler();
        me.visual.find(".button-toggle-active").trigger("click");
        me.visual.find("#detailContent").height(me.height-200);
        return true;
    } catch (ex) {
        me.writeError('ProjectDetails.init', ex);
        return false;
    }

};

ProjectDetails.prototype.loadDetailForms = function () {
    /// <summary>
    /// This functio is used for the various options in the logger/project/customer detailview. <br/>
    /// Currently the following types are supported <br/>
    /// <list type="bullet">
    /// <item>
    /// <description>'logger' loads the logger and device form</description>
    /// </item>
    /// <item>
    /// <description>'customer' loads the customer form</description>
    /// </item>
    /// <item>
    /// <description>'location' loads the geocoding widget</description>
    /// </item>
    /// <item>
    /// <description>'user2logger' assignment of users to the current logger</description>
    /// </item>
    /// <item>
    /// <description>'rights2project' assignments of right-groups to the current logger</description>
    /// </item>
    /// <item>
    /// <description>'loggerDel' deletion of logger</description>
    /// </item>
    /// </list>    
    /// </summary>
    var me = this;
    var type;
    try {
        if (me.error) { return false; }
        //init list entry click handler
        type = me.visual.find('.button-toggle-active').attr("data-projectdetail");

        me.vcVisual.setShowFullscreen(false);
        me.vcVisual.setShowHeaderMenu(false);
        me.visual.find("#detailContent").html(me.vcC.getLoadingIcon());
        switch (type) {
            case "logger":
                me.vcVisual.addVisualBaseByName('de', 'WIDGET_PROJECT_PROJECTFORM', 'tailContent',  window.getCurrentTimestamp(), me.visual.find('#detailContent').height(), me.visual.find('#detailContent').width(), '', JSON.stringify({ "newProject": me.newProject, 'loggerid': me.ids.loggerid, 'customerid': me.ids.customerid }), me.deviceType);
                break;
            case "customer":
                me.vcVisual.addVisualBaseByName('d', 'WIDGET_PROJECT_CUSTOMERFORM', 'etailContent', window.getCurrentTimestamp(), me.visual.find('#detailContent').height(), me.visual.find('#detailContent').width(), '', JSON.stringify({ 'customerid': me.ids.customerid }), me.deviceType);

                break;
            case "location":
                me.vcVisual.addVisualBaseByName('deta', 'VISUAL_WIDGET_GEOCODING', 'ilContent', window.getCurrentTimestamp(), me.visual.find('#detailContent').height(), me.visual.find('#detailContent').width(), "2" + "," + me.ids.deviceid.toString(), '', me.deviceType);

                break;
            case "user2logger":
                me.vcVisual.addVisualBaseByName('detai', 'VISUAL_MEMBERSHIP_ASSIGNMENT_USER2LOGGER', 'lContent', window.getCurrentTimestamp(), me.visual.find('#detailContent').height(), me.visual.find('#detailContent').width(), JSON.stringify({ "AssID": me.ids.loggerid }), "", me.deviceType);
                break;
            case "rights2project":
                me.vcVisual.addVisualBaseByName('detailC', 'VISUAL_MEMBERSHIP_ASSIGNMENT_GROUP2SINGLELOGGER', 'ontent', window.getCurrentTimestamp(), me.visual.find('#detailContent').height(), me.visual.find('#detailContent').width(), JSON.stringify({ "AssID": me.ids.loggerid }), "", me.deviceType);
                break;   
            case "loggerDel":
                me.vcVisual.addVisualBaseByName('detailCo', 'WIDGET_PROJECT_DELETION', 'ntent', window.getCurrentTimestamp(), me.visual.find('#detailContent').height(), me.visual.find('#detailContent').width(), JSON.stringify({ 'id': me.ids.loggerid }), "", me.deviceType);
                break;
            case "contacts":
                me.vcVisual.addVisualBaseByName('detailCon', 'WIDGET_PROJECT_CONTACT_MANAGER', 'tent', window.getCurrentTimestamp(), me.visual.find('#detailContent').height(), me.visual.find('#detailContent').width(), "", JSON.stringify({ 'loggerid': me.ids.loggerid }), me.deviceType);
                break;
            default:
                me.visual.find("#detailContent").html("button unbekannt");
                break;
        }


        return true;

    } catch (ex) { me.writeError("ProjectDetails.loadDetailForms", ex); return false; }
};

ProjectDetails.prototype.doEvent = function (event) {
    /// <summary>
    /// calls the button back function when a project got deleted
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
if (event.msg === "MS_CLOSE_PROJECT") {
    me.btnBack();
}
return true;
    } catch (ex) { me.writeError("ProjectDetails.doEvent", ex); return false; }
};

ProjectDetails.prototype.btnBack = function () {
    /// <summary>
    /// Handles the click of the back button <br/>
    /// by calling the webservice and calling the overview list again, needs to be 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.visual.hide();
        window._VCMQ.produce(me.visual, me.vcgid, 'PROJECT_DET_BACK', {});
        return true;
    } catch (ex) {
        me.writeError('ProjectDetails.btnBack', ex);
        return false;
    }
};
ProjectDetails.prototype.initClickHandler = function () {
    var me = this;
    try {
        if (me.error) { return false; }

        me.visual.find('#divBackFromDetailsToProjectOverview').button().off("click").on("click", function () {
            me.btnBack();
        });
        me.visual.find(".button-toggle").button().off("click").on("click", function () {
            me.visual.find(".button-toggle").removeClass("button-toggle-active");
            $(this).addClass("button-toggle-active");
            me.loadDetailForms();
        });
        return true;
    } catch (ex) {
        me.writeError('ProjectDetails.initClickHandler', ex);
        return false;
    }
};

ProjectDetails.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('.toggle-button, #divContent').hide();
        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};